import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_LMS_CONFIG = 'SET_LMS_CONFIG';
export const SET_LMS_LOADING = 'SET_LMS_LOADING';
export const SET_LMS_ERROR = 'SET_LMS_ERROR';

export const setLmsConfig = (data) => ({ type: SET_LMS_CONFIG, payload: data });
export const setLmsLoading = (v) => ({ type: SET_LMS_LOADING, payload: v });
export const setLmsError = (e) => ({ type: SET_LMS_ERROR, payload: e });

// GET /api/settings/lms-config — any authenticated user (no secret returned).
// Used by the Settings page AND the nav to decide whether to show "Heidi LMS".
// Silent on failure so it never raises a global error toast for normal users.
export const getLmsConfig = () => (dispatch) => {
  dispatch(setLmsLoading(true));
  return axios
    .get(`${API_BASE_URL}/api/settings/lms-config`)
    .then((response) => {
      dispatch(setLmsConfig(response.data));
      dispatch(setLmsLoading(false));
      return response.data;
    })
    .catch((err) => {
      dispatch(setLmsLoading(false));
      dispatch(setLmsError(err.response?.data?.message || 'Failed to load Heidi LMS configuration'));
      // swallow — nav/settings degrade gracefully (LMS treated as disabled)
    });
};

// POST /api/settings/lms-config — super-admin only.
// config: { enabled, portal_url, token? } (omit token to keep the existing one).
export const updateLmsConfig = (config) => (dispatch) => {
  dispatch(setLmsLoading(true));
  return axios
    .post(`${API_BASE_URL}/api/settings/lms-config`, config)
    .then((response) => {
      dispatch(showMessage({ message: 'Heidi LMS configuration saved' }));
      dispatch(setLmsConfig(response.data));
      dispatch(setLmsLoading(false));
      return response.data;
    })
    .catch((err) => {
      dispatch(setLmsLoading(false));
      const msg = err.response?.data?.message || err.response?.data?.error || 'Failed to save Heidi LMS configuration';
      dispatch(showMessage({ message: msg, variant: 'error' }));
      dispatch(setLmsError(msg));
      throw err;
    });
};
